/* eslint-disable */
/// This file is auto generated - do not edit manually
export const TotalText = 'Website.Product.SmartBundle.TotalText';
export const SingleItem = 'Website.Product.SmartBundle.SingleItem';
export const MultipleItems = 'Website.Product.SmartBundle.MultipleItems';
export const AddToBasketButtonText = 'Website.Product.SmartBundle.AddToBasketButtonText';
export const AddMultipleToBasketButtonText = 'Website.Product.SmartBundle.AddMultipleToBasketButtonText';
export const DisabledAddToBasketButtonText = 'Website.Product.SmartBundle.DisabledAddToBasketButtonText';
export const CurrentProductSplash = 'Website.Product.SmartBundle.CurrentProductSplash';
export const AddedToBasketMessage = 'Website.Product.SmartBundle.AddedToBasketMessage';
export const AddedMultipleToBasketMessage = 'Website.Product.SmartBundle.AddedMultipleToBasketMessage';
